import graphAxios from "@/helpers/api/apiGraph";

export default {
  splitArrayToBatchChunks(array) {
    const chunkSize = 20;
    var R = [];
    for (var i = 0, len = array.length; i < len; i += chunkSize) R.push(array.slice(i, i + chunkSize));
    return R;
  },

  makeBatchRequest(requestArray) {
    return new Promise((resolve, reject) => {
      const chunks = this.splitArrayToBatchChunks(requestArray);
      const promises = [];

      chunks.map(ch => {
        // The URI should be complete with graph.microsoft.com to work for batch
        promises.push(graphAxios.post(`https://graph.microsoft.com/beta/$batch`, { requests: ch }));
      });

      Promise.all(promises)
        .then(results => resolve([].concat(...results.map(re => re.data.responses))))
        .catch(error => {
          reject(error);
        });
    });
  }
};
